var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "codigo", tooltip: _vm.form.codigo },
                model: {
                  value: _vm.form.codigo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "codigo", $$v)
                  },
                  expression: "form.codigo"
                }
              },
              [
                _c("span", [_vm._v("Código*")]),
                _vm._v(" "),
                _vm.errores.codigo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.codigo[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-8" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "nombre", tooltip: _vm.form.descripcion },
                model: {
                  value: _vm.form.descripcion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "descripcion", $$v)
                  },
                  expression: "form.descripcion"
                }
              },
              [
                _c("span", [_vm._v("Nombre*")]),
                _vm._v(" "),
                _vm.errores.descripcion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.descripcion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "codigo_barra", tooltip: _vm.form.codigo_barra },
                model: {
                  value: _vm.form.codigo_barra,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "codigo_barra", $$v)
                  },
                  expression: "form.codigo_barra"
                }
              },
              [
                _c("span", [_vm._v("Cód. Barra")]),
                _vm._v(" "),
                _vm.errores.codigo_barra
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.codigo_barra[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-8" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Foto")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.url_foto != null || _vm.form.archivo != null,
                      expression:
                        "form.url_foto != null || form.archivo != null"
                    }
                  ],
                  staticClass: "btn-warning",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.eliminarArchivo()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.url_foto != null && _vm.form.archivo == null,
                      expression:
                        "form.url_foto != null && form.archivo == null"
                    }
                  ],
                  staticClass: "btn-info",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarArchivo()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c("fileUpload", {
                ref: "archivo",
                attrs: {
                  id: "archivo",
                  extensiones: ".JPEG,.gif,.jpg,.png,.PNG,.JPG",
                  pathDefault: "/images/no-logo.png",
                  defaultImage:
                    _vm.form.url_foto != null
                      ? _vm.form.url_foto
                      : "/images/no-logo.png",
                  tamanoMaximo: 5000000,
                  descripcionMaximo: "5mb",
                  cargarImagenDefecto: "",
                  verMiniatura: ""
                },
                on: {
                  imagenCargada: function($event) {
                    return _vm.setearArchivo()
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  id: "precio",
                  placeholder: "$ #,###.##"
                },
                model: {
                  value: _vm.form.precio,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "precio", $$v)
                  },
                  expression: "form.precio"
                }
              },
              [
                _c("span", [_vm._v("Precio 1")]),
                _vm._v(" "),
                _vm.errores.precio
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.precio[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  id: "precio2",
                  placeholder: "$ #,###.##"
                },
                model: {
                  value: _vm.form.precio2,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "precio2", $$v)
                  },
                  expression: "form.precio2"
                }
              },
              [_vm._v("\n          Precio 2\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  id: "precio3",
                  placeholder: "$ #,###.##"
                },
                model: {
                  value: _vm.form.precio3,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "precio3", $$v)
                  },
                  expression: "form.precio3"
                }
              },
              [_vm._v("\n          Precio 3\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { vMoney: "", format: _vm.money, id: "costo" },
                model: {
                  value: _vm.form.costo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "costo", $$v)
                  },
                  expression: "form.costo"
                }
              },
              [
                _c("span", [_vm._v("Costo")]),
                _vm._v(" "),
                _vm.errores.costo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.costo[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.cerrar }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _c("span", [_vm._v("Guardar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [_c("h3", [_vm._v("ITEM")])])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a7ef0db", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7ef0db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/EdicionItem.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7a7ef0db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/EdicionItem.vue
// module chunks = 0